import React from 'react';
import PropTypes from 'prop-types';
import apiClient from 'clients/apiClient';
import authHelper from 'helpers/auth';
import config from 'helpers/config';
import InvitationRequestsList from './InvitationRequestsList';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import { showNotification } from 'store/actions/uiActions';
import { connect } from 'react-redux';
import Notification from 'components/notifications/Notification';

class InvitationRequestsContainer extends React.Component {
    constructor() {
        super();
        this.acceptInvitationHandler = this.acceptInvitationHandler.bind(this);
        this.declineInvitationHandler = this.declineInvitationHandler.bind(this);

        this.state = {
            invitationsStatus: [],
            error: null,
            invitations: null,
            isLoading: false,
        };
    }

    componentDidMount() {
        this.fetchInvitations();
    }

    acceptInvitationHandler(id) {
        const { invitations, invitationsStatus } = this.state;
        const { showNotification } = this.props;
        const url = `${ config.getApiBaseUrl() }/@me/accounts/invitations/${ id }/accept`;
        const hasAccount = !!authHelper.getAccount();
        const acceptedInvitation = {
            id: id,
            label: 'notifications.invitations.accepted',
        };

        apiClient.create(url).then(() => {
            showNotification('notifications.invitations.accepted', 'success');

            this.setState({
                invitationsStatus: [
                    ...invitationsStatus,
                    acceptedInvitation,
                ],
            }, () => {
                if (!hasAccount && invitations.length === 1) {
                    window.location.href = '/';
                }
            });

        }).catch((err) => {
            showNotification(err.response.message, 'warning');
        });
    }

    declineInvitationHandler(id) {
        const { invitationsStatus } = this.state;
        const { showNotification } = this.props;
        const url = `${ config.getApiBaseUrl() }/@me/accounts/invitations/${ id }/deny`;
        const deniedInvitation = {
            id: id,
            label: 'notifications.invitations.denied',
        };

        apiClient.create(url).then(() => {
            showNotification('notifications.invitations.denied', 'success');

            this.setState({
                invitationsStatus: invitationsStatus ? [
                    ...invitationsStatus,
                    deniedInvitation,
                ] : [
                    deniedInvitation,
                ],
            }, () => {
                this.fetchInvitations();
            });
        }).catch((err) => {
            showNotification(err.response.message, 'warning');
        });
    }

    fetchInvitations() {
        const url = `${ config.getApiBaseUrl() }/@me/accounts/invitations`;

        this.setState({ isLoading: true });

        apiClient.read(url).then((response) => {
            this.setState({
                invitations: response.results,
                isLoading: false,
            });
        }).catch((err) => {
            this.setState({
                error: err,
                isLoading: false,
            });
        });
    }

    render() {
        const { invitationsStatus, error, invitations, isLoading } = this.state;

        if (isLoading) {
            return <LoadingCard />;
        }

        if (error) {
            return <ResourceNotFound />;
        }

        return (
            <div>
                <InvitationRequestsList
                    invitationsStatus={ invitationsStatus }
                    invitations={ invitations }
                    onAcceptInvitation={ this.acceptInvitationHandler }
                    onDenyInvitation={ this.declineInvitationHandler }
                />

                <Notification />
            </div>
        );
    }
}

InvitationRequestsContainer.propTypes = {
    showNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (msg, type) => {
            dispatch(showNotification(msg, type));
        },
    };
};

export default connect(null, mapDispatchToProps)(InvitationRequestsContainer);



// WEBPACK FOOTER //
// ./src/pages/invitations/requests/InvitationRequestsContainer.js